module.exports = __webpack_public_path__ + "static/media/map-background.3673b0df.jpg";